/* global $ */
// Remove site preloader after site is loaded
$(window).load(function () {
  $('#sitePreloader').delay(200).fadeOut(500, function () {
    $(this).remove()
  })
// Fade site in
  $('.container').delay(700).fadeIn(500)
})
